import React from "react";
import caption from "lib/translation";
import { getString } from "lib/translation";
import config from "lib/config";
import Loading from "lib/components/loader";

export default class LuvitComponent extends React.Component {
  constructor(props, context, langContext, placeholder) {
    super(props, context);

    this._placeholder = placeholder;

    if (langContext) {
      this.langContext = langContext;
      let promise = caption(langContext);
      if (promise._loaded) {
        this.__loaded = true;
        this.state = {};
      } else
        promise.then(() => {
          this.setState({ __loaded: true });
        });
    }

    this.path = config.urlRoot;
  }

  l(key, suffix) {
    return getString(this.langContext, key, suffix);
  }

  getQuery() {
    let q = document.location.href.split("?");

    q = q.length > 1 ? q[1] : "";

    let i = q.indexOf("_k=");
    if (i >= 0) q = q ? q.substr(0, i - 1) : "";

    return q;
  }

  isPureHash() {
    return document.location.href.indexOf(".aspx") == -1;
  }

  getClientUrl(url) {
    if (!this.isPureHash()) return url;

    return this.path + url;
  }

  getClientUrlWithSameQuery(url) {
    if (!this.isPureHash()) return url;

    return this.getClientUrl(url) + "?" + this.getQuery();
  }

  render() {
    if (!this.__loaded && (!this.state || !this.state.__loaded))
      return this._placeholder || <Loading immediate={false} />;

    if (this.doRender) return this.doRender();

    return <div>Component does not contain a doRender definition...</div>;
  }
}
